module.exports = __webpack_public_path__ + "img/panel_h_s.865de499.png";